import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import useFormContext from "./GetEventMarsComplete.jsx/useFormMarsComplete";
import "reactjs-popup/dist/index.css";
import ConfirmationModalDecline from "./GetEventMarsComplete.jsx/ConfirmationModal";
import AdditionalPopupDecline from "./GetEventMarsComplete.jsx/AdditionalPopup";
import ConfirmationModalAccept from "./GetEventMarsComplete.jsx/ConfirmationModalAccept";
import AdditionalPopupAccept from "./GetEventMarsComplete.jsx/AdditionalPopupAccept";
import ConfirmationModalTentative from "./GetEventMarsComplete.jsx/ConfirmationModalTentative";
import AdditionalPopupTentative from "./GetEventMarsComplete.jsx/AdditionalPopupTentative";
import {
  GET_VCS_FILE
} from './ApiDetails.js';
import axios from "axios";

export default function Footer() {
  const {
    eventFormData,
    ProcessEventInvitation,
    userAcceptConfirmed,
    userDeclined,
    userTentative
  } = useFormContext();
  
    const navigateToApp = (role) => {
        // Role-based redirection
        switch (role) {
            case 'Visit Requester':
            case 'Requester':
                navigate('/AppRequester');
                break;
            case 'Admin':
                navigate('/AppAdmin');
                break;
            case 'Family':
                navigate('/AppFamily');
                break;
            case 'MLTUser':
                navigate('/AppMltEvent');
                break;
            case 'FamilyCoordinator':
                navigate('/AppFamily');
                break;
            case 'MLTCoordinator':
                navigate('/AppMltEvent');
                break;
            default:
                navigate('/');  // Redirect to home or login in case of an invalid role
                break;
        }
    }

  const [isDeclineModalOpen, setIsDeclineModalOpen] = useState(false);
  const [isAcceptModalOpen, setIsAcceptModalOpen] = useState(false);
  const [isTentativeModalOpen, setIsTentativeModalOpen] = useState(false);
  const [isAdditionalPopupDeclineOpen, setIsAdditionalPopupDeclineOpen] = useState(false);
  const [isAdditionalPopupAcceptOpen, setIsAdditionalPopupAcceptOpen] = useState(false);
  const [isAdditionalPopupTentativeOpen, setIsAdditionalPopupTentativeOpen] = useState(false);

  //for decline invitation
  const handleDeclineClick = () => {
    setIsDeclineModalOpen(true);
  };

  const handleDeclineSaveClick = (comment) => {
    ProcessEventInvitation("Declined", comment);
    setIsDeclineModalOpen(false);
    setIsAdditionalPopupDeclineOpen(true);
  };

  const handleDeclineCancelClick = (e) => {
    e.preventDefault();
    setIsDeclineModalOpen(false);
  };

  const handleAdditionalPopupDeclineClose = () => {
    setIsAdditionalPopupDeclineOpen(false);
  };

  // for accept invitation

  const handleAcceptClick = () => {
    setIsAcceptModalOpen(true);
  };

  const handleAcceptSaveClick = (comment) => {
    ProcessEventInvitation("Confirmed", comment);
    setIsAcceptModalOpen(false);
    setIsAdditionalPopupAcceptOpen(true);
    navigateToApp(localStorage.getItem('role'));
  };

  const handleAcceptCancelClick = (e) => {
    e.preventDefault();
    setIsAcceptModalOpen(false);
  };

  const handleAdditionalPopupAcceptClose = () => {
    setIsAdditionalPopupAcceptOpen(false);
  };

  // for tentative invitation

  const handleTentativeClick = () => {
    setIsTentativeModalOpen(true);
  };

  const handleTentativeSaveClick = (comment) => {
    ProcessEventInvitation("Tentative", comment);
    setIsTentativeModalOpen(false);
    setIsAdditionalPopupTentativeOpen(true);
  };

  const handleTentativeCancelClick = (e) => {
    e.preventDefault();
    setIsTentativeModalOpen(false);
  };

  const handleAdditionalPopupTentativeClose = () => {
    setIsAdditionalPopupTentativeOpen(false);
  };

  const fileDownload = require('js-file-download');
  const downloadVCSFile = () => {
    axios.get(`${GET_VCS_FILE}/${eventFormData.eventId}`)
      .then(response => {
        fileDownload(response.data, `${eventFormData.eventTitle}_${eventFormData.eventId}.vcs`);
      })
      .catch(error => {
        console.error('Error updating the details: ', error);
      });
  }

  const navigate = useNavigate();

  return (
    <footer className="footer">
      <div className="container-fluid">
        <div className="row footerButtonsContainer">
          <div className="col-md-6">
            <button
              type="button"
              className="btn btn-outline-light left-button"
              onClick={() => navigate(-1)}
            >
              Back
            </button>
          </div>
          {eventFormData.eventStatus !== 'Completed' ?
            (
              <div className="col-md-6 text-end">
                {(!userDeclined && ((eventFormData.eventStatus === "Open event") || (eventFormData.eventStatus === "Attendance confirmed"))) && (
                  <button type="button" id="rejectEvent" className="btn btn-outline-light right-buttons footerButtons footerButtonsMarsf"
                    onClick={handleDeclineClick}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x" viewBox="0 0 16 16">
                      <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 1 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                    </svg>
                    <span>DECLINE INVITATION</span>
                  </button>
                )}

                {(!userTentative && ((eventFormData.eventStatus === "Open event") || (eventFormData.eventStatus === "Attendance confirmed"))) && (
                  <button
                    type="button"
                    id="ReturnToRequestor"
                    className="btn btn-outline-light right-buttons footerButtons footerButtonsMarsf"
                    onClick={handleTentativeClick}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="white">
                      <path d="M12 22a10 10 0 1110-10 10.011 10.011 0 01-10 10zm0-18a8 8 0 108 8 8.009 8.009 0 00-8-8zm4 9h-5a1 1 0 01-1-1V7a1 1 0 112 0v4h4a1 1 0 010 2z" />
                    </svg>
                    <span>TENTATIVE</span>
                  </button>
                )}

                {(!userAcceptConfirmed && ((eventFormData.eventStatus === "Open event") || (eventFormData.eventStatus === "Attendance confirmed"))) && (
                  <button
                    type="button"
                    id="ValidateOpen"
                    className="buttonrequest btn btn-outline-light right-buttons footerButtons footerButtonsMarsf"
                    onClick={handleAcceptClick}
                  >
                    <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg"                  >
                      <path d="M1.16523 3.72227L0.615234 4.27227L2.16211 5.81914C2.33398 5.99102 2.64336 5.99102 2.84961 5.81914L8.31524 0.353516L7.24961 0.353516L2.54023 5.06289L1.16523 3.72227Z" fill="currentColor" />
                    </svg>
                    <span>ACCEPT INVITATION</span>
                  </button>
                )}

                {userAcceptConfirmed && (
                  <a href="#" onClick={(e) => { e.preventDefault(); downloadVCSFile(); }}>
                    <button
                      type="button"
                      id="AddToCalendar"
                      className="buttonrequest btn btn-outline-light right-buttons footerButtons footerButtonsMarsf"
                    >
                      <span>Add event to your Outlook calendar</span>
                    </button>
                  </a>
                )}

                <ConfirmationModalAccept
                  isOpen={isAcceptModalOpen}
                  onClose={() => setIsAcceptModalOpen(false)}
                  onSave={(comment) => handleAcceptSaveClick(comment)}
                  onCancel={handleAcceptCancelClick}
                  commentMandatory={false}
                  placeHolderText="I accept this invitation."
                />
                <AdditionalPopupAccept
                  isOpen={isAdditionalPopupAcceptOpen}
                  onClose={handleAdditionalPopupAcceptClose}
                />
                <ConfirmationModalTentative
                  isOpen={isTentativeModalOpen}
                  onClose={() => setIsTentativeModalOpen(false)}
                  onSave={(comment) => handleTentativeSaveClick(comment)}
                  onCancel={handleTentativeCancelClick}
                  commentMandatory={false}
                  placeHolderText="I might accept this invitation."
                />
                <AdditionalPopupTentative
                  isOpen={isAdditionalPopupTentativeOpen}
                  onClose={handleAdditionalPopupTentativeClose}
                />
                <ConfirmationModalDecline
                  isOpen={isDeclineModalOpen}
                  onClose={() => setIsDeclineModalOpen(false)}
                  onSave={(comment) => handleDeclineSaveClick(comment)}
                  onCancel={handleDeclineCancelClick}
                  commentMandatory={true}
                  placeHolderText="I decline this invitation."
                />
                <AdditionalPopupDecline
                  isOpen={isAdditionalPopupDeclineOpen}
                  onClose={handleAdditionalPopupDeclineClose}
                />
              </div>
            ) :
            (
              <div className="col-md-6 text-end"></div>
            )
          }
        </div>
      </div>
    </footer>
  );
}
